import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import PageHero from '../../components/base/PageHero';

export default function OrderBridalPage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "オーダー・ブライダルジュエリー - ジュエリーおかやま",
      "description":
        "岡山市のジュエリーおかやまのオーダーメイドジュエリーとブライダルジュエリーのコレクション。婚約指輪、結婚指輪、カスタムジュエリーを取り揃えています。",
      "url": `${siteUrl}/order-bridal`,
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const orderProducts = [
    {
      id: 1,
      name: 'カスタムダイヤモンドリング',
      price: '¥200,000〜',
      description: '世界に一つだけのデザイン。ダイヤモンドの形・カット・サイズをお客様と一緒に選びます。',
      image:
        'https://public.readdy.ai/ai/img_res/e59012b9ff443e63068184cfc5fb6548.jpg',
    },
    {
      id: 2,
      name: 'オーダーメイドネックレス',
      price: '¥150,000〜',
      description: '素材・チェーンの長さ・ペンダントトップのデザインまで細部にこだわってお作りします。',
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/f6b17b4a42e094056ea39dd4f7cf7c7d.jpeg',
    },
    {
      id: 3,
      name: 'パーソナライズドブレスレット',
      price: '¥80,000〜',
      description: '名前や記念日を刻印できるオプションも人気。大切な想いを手元に添えて。',
      image:
        'https://readdy.ai/api/search-image?query=delicate%20personalized%20bracelet%20with%20elegant%20design%20on%20white%20display%20stand%20soft%20studio%20lighting%20cream%20background%20luxury%20jewelry%20product%20photography&width=600&height=700&seq=order3&orientation=portrait',
    },
    {
      id: 4,
      name: 'カスタムピアス',
      price: '¥60,000〜',
      description: '左右非対称デザインや揺れるタイプなど、個性を表現するピアスをご提案します。',
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/b1be61ade7d0b96c1f4f2a26e771e029.jpeg',
    },
    {
      id: 5,
      name: 'オーダーメイドリング',
      price: '¥120,000〜',
      description: '指のサイズや形に合わせた完全フィット。素材はゴールド・プラチナからお選びいただけます。',
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/67068b4e5d715a549d9200696f4fcfca.jpeg',
    },
    {
      id: 6,
      name: 'カスタムアンクレット',
      price: '¥50,000〜',
      description: '繊細なチェーンワークと天然石の組み合わせで、さりげない輝きを足元に添えます。',
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/788eb96dc45f192dbd1a4fed35092b04.jpeg',
    },
  ];

  const bridalProducts = [
    {
      id: 1,
      name: 'プラチナ婚約指輪',
      price: '¥250,000〜',
      description: '純度の高いプラチナに厳選ダイヤモンドをセット。永遠の愛を象徴する一本です。',
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/44731be25e6de7ee5eb80ed9a89a17e7.jpeg',
    },
    {
      id: 2,
      name: 'ゴールド結婚指輪ペア',
      price: '¥180,000〜',
      description: 'ふたりの絆を結ぶペアリング。シンプルながら上質なゴールドの輝きが特徴です。',
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/5b1fe755483add46fa803108c9afa528.jpeg',
    },
    {
      id: 3,
      name: 'ダイヤモンド婚約指輪',
      price: '¥300,000〜',
      description: 'GIA鑑定書付きのダイヤモンドを使用。カットの美しさが最大限に輝くデザインです。',
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/71d4b6621ec9e1b46c687b094abd8a7c.jpeg',
    },
    {
      id: 4,
      name: 'シンプル結婚指輪ペア',
      price: '¥120,000〜',
      description: '毎日身に着けやすいシンプルなデザイン。内側への刻印サービスも承っています。',
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/1ec822e7b74cc17c8821a95f2df365a3.jpeg',
    },
    {
      id: 5,
      name: 'エタニティリング',
      price: '¥220,000〜',
      description: '全周にダイヤモンドを敷き詰めたエタニティデザイン。結婚記念日の贈り物にも最適です。',
      image:
        'https://readdy.ai/api/search-image?query=beautiful%20eternity%20ring%20with%20continuous%20diamonds%20on%20elegant%20display%20stand%20soft%20romantic%20lighting%20cream%20background%20luxury%20bridal%20jewelry&width=600&height=700&seq=bridal5&orientation=portrait',
    },
    {
      id: 6,
      name: 'アンティーク調婚約指輪',
      price: '¥280,000〜',
      description: 'ミル打ちや透かし彫りなどクラシカルな技法を用いた、時代を超えた美しさの一本です。',
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/0c67be157523a505aa34faa5334d87ea.jpeg',
    },
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <PageHero
          title="オーダー・ブライダルジュエリー"
          subtitle="あなただけの特別なジュエリーを"
          image="https://readdy.ai/api/search-image?query=close-up%20of%20beautiful%20engagement%20ring%20with%20sparkling%20diamond%20soft%20romantic%20lighting%20cream%20and%20white%20tones%20luxury%20bridal%20jewelry%20elegant%20composition%20high%20quality%20product%20photography&width=1920&height=600&seq=order-bridal-hero&orientation=landscape"
        />

        {/* Order Made Section */}
        <section className="py-20 lg:py-28 bg-cream-100" data-product-shop="">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold text-center text-brown-600 mb-16">
              オーダーメイドジュエリー
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {orderProducts.map((product) => (
                <article
                  key={product.id}
                  className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
                >
                  <div className="w-full h-80">
                    <img
                      src={product.image}
                      alt={`${product.name} - 岡山のジュエリーおかやま`}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                  <div className="p-6 text-center">
                    <h3 className="text-xl font-serif font-semibold text-brown-600 mb-2">
                      {product.name}
                    </h3>
                    <p className="text-lg font-serif text-brown-400 mb-3">
                      {product.price}
                    </p>
                    <p className="text-sm font-serif text-brown-500 leading-relaxed">
                      {product.description}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Bridal Section */}
        <section className="py-20 lg:py-28 bg-white" data-product-shop="">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold text-center text-brown-600 mb-16">
              ブライダルジュエリー
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {bridalProducts.map((product) => (
                <article
                  key={product.id}
                  className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
                >
                  <div className="w-full h-80">
                    <img
                      src={product.image}
                      alt={`${product.name} - 岡山のジュエリーおかやま`}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                  <div className="p-6 text-center">
                    <h3 className="text-xl font-serif font-semibold text-brown-600 mb-2">
                      {product.name}
                    </h3>
                    <p className="text-lg font-serif text-brown-400 mb-3">
                      {product.price}
                    </p>
                    <p className="text-sm font-serif text-brown-500 leading-relaxed">
                      {product.description}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="py-20 lg:py-28 bg-cream-100">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold text-center text-brown-600 mb-16">
              オーダーメイドの流れ
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
              {[
                { step: '01', title: 'ご相談', desc: 'イメージやご予算をお伺いします' },
                { step: '02', title: 'デザイン', desc: '専門スタッフがデザインを提案' },
                { step: '03', title: 'お見積り', desc: '詳細な見積もりをご提示' },
                { step: '04', title: '制作', desc: '熟練職人が丁寧に制作' },
                { step: '05', title: 'お渡し', desc: '完成品をお渡しします' },
              ].map((item, index) => (
                <article key={index} className="text-center relative">
                  <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-brown-400 flex items-center justify-center">
                    <span className="text-2xl font-serif font-bold text-white">{item.step}</span>
                  </div>
                  <h3 className="text-xl font-serif font-semibold text-brown-600 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-brown-500 font-serif">{item.desc}</p>
                  {index < 4 && (
                    <div className="hidden md:block absolute top-10 left-[60%] w-[80%] h-0.5 bg-brown-200">
                      <i className="ri-arrow-right-line absolute -right-2 -top-2 text-brown-400 text-xl"></i>
                    </div>
                  )}
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
